import * as React from 'react';
import { Edition } from '@shapeable/gesda-types';

export const EditionsContext = React.createContext<Edition[]>([]);
export const EditionsProvider = EditionsContext.Provider;